import { NgClass, NgIf } from '@angular/common';
import { AfterContentInit, AfterViewInit, Component, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Data, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { AdminService } from './admin/admin.service';
import { AuthServiceService } from './auth/auth-service.service';
import { PreviousSearchesBurgerService } from './data-cleaner/previous-searches-burger/previous-searches-burger.service';
import { HamburgerComponent } from './header/hamburger/hamburger.component';
import { HamburgerService } from './header/hamburger/hamburger.service';
import { HeaderComponent } from './header/header.component';
import { LoadingComponent } from './loading/loading.component';
import { DataToolsApps, DataToolsAuth } from './shared/DataToolsApps';
import { IDialogData, KyloeConfirmDialogComponent } from './shared/kyloe-confirm-dialog/kyloe-confirm-dialog.component';
import { AlertBannerComponent } from './shared/services/alert-banner/alert-banner.component';
import { AwsRumService } from './shared/services/analytics/aws-rum.service';
import { GoogleAnalyticsService } from './shared/services/analytics/google-analytics.service';
import { PendoService} from './shared/services/analytics/pendo.service';
import { DatatoolsLiteService } from './shared/services/datatools-lite.service';
import { MessageAction, MessageNotificationService } from './shared/services/message-notification.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    HamburgerComponent,
    HeaderComponent,
    AlertBannerComponent,
    RouterOutlet,
    LoadingComponent,
    NgIf,
    NgClass,
    MatTooltip
  ]
})
export class AppComponent implements AfterContentInit, OnInit, AfterViewInit {
  pageTitle = 'DataToolsUi';
  version: string;
  expandVersion = false;
  dataToolsApps = DataToolsApps;
  routeClass: string[] = [];
  @ViewChild('alertbanner')
  alertBanner: AlertBannerComponent;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private hamburgerService: HamburgerService,
              private previousSearchesBurgerService: PreviousSearchesBurgerService,
              private authService: AuthServiceService,
              private adminService: AdminService,
              private dialog: MatDialog,
              private datatoolsLiteService: DatatoolsLiteService,
              private awsRumService: AwsRumService,
              private gaService: GoogleAnalyticsService,
              private pendoService: PendoService,
              private messageNotificationService: MessageNotificationService
  ) {
    this.version = environment.version;
    this.routeClass = this.buildRouteClasses(router.url);
    router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.routeClass = this.buildRouteClasses(e.urlAfterRedirects);
      }
    });
    this.listenForRestrictedAccess();
  }

  ngAfterViewInit() {
    this.messageNotificationService.message$.subscribe(message => {
      if (message.action === MessageAction.SHOW)
        this.alertBanner.show(message.message);
      else
        this.alertBanner.hide(message.message);
    });
  }

  copyToClipboard(msg: any): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', msg);
      e.preventDefault();
      document.removeEventListener('copy', listener);
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
  }

  ngOnInit(): void {

    this.authService.isAuthing$.subscribe(success => {
      console.log('Authing State changing');
      console.log(success);
      if (success === DataToolsAuth.COMPLETE) {
        this.adminService.loadApps();
      }
    });

    if (this.authService.checkAuthIsValid()) {
      this.adminService.loadApps();
    }

    this.initialiseAnalytics();
  }

  isAuthing() {
    return (this.authService.getAuthState() === DataToolsAuth.IN_PROGRESS);
  }

  ngAfterContentInit() {
    this.route.data.subscribe(
        (data: Data) => {
          this.pageTitle = data['title'];
        }
    );
  }

  closeBurger() {
    this.hamburgerService.closeHamburger();
  }

  private buildRouteClasses(url: string): string[] {
    const segments = url.split('?')[0].split('/').filter(s => s);
    return segments.map((_, i) => segments.slice(0, i + 1).join('-'));
  }

  listenForRestrictedAccess() {
    this.datatoolsLiteService.triggerMessage$.subscribe((message) => {
      this.dialog.open(KyloeConfirmDialogComponent, {
        data: {
          titleIcon: '',
          title: 'Kyloe DataTools Lite',
          hideCancelButton: true,
          hideConfirmButton: true,
          image: '/images/DTLite-upgrademessage.png',
        } as IDialogData
      });
    });
  }

  // Keyboard Shortcuts
  // - Use Alt + Shift + V to enlarge version number
  // - Use Alt + Shift + M to open Menu/Hamburger
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (event.altKey && event.shiftKey) {
      if (event.code === 'KeyV') {
        this.expandVersion = true;
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        }, 200);
        setTimeout(() => {
          this.expandVersion = false;
        }, 1500);
      }
      if (event.code === 'KeyM') {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
        this.hamburgerService.openHamburger();
      }
    }
  }

  private initialiseAnalytics(): void {
    this.pendoService.initPendoScript(environment.pendoAPIKey);
    this.awsRumService.init();
    this.adminService.finishedCheckingApps$.subscribe((checkedApps) => {
      if (checkedApps)
        this.gaService.init();
    });
  }

}
